<template>
  <div>

    <!-- FILTERS -->
    <v-btn color="primary" flat @click="reset">Reset filtering</v-btn>
    <v-btn
      v-if="getIsMaster || getIsSuperUser"
      color="info"
      @click="downloadAttendeesExcelAll"
    >
      Download Attendees
    </v-btn>
<!--    <v-btn color="info" @click="downloadAttendeesExcel">
      Download Attendees
    </v-btn>
    <v-btn color="info" @click="showModalForColumnsChoose">Choose columns</v-btn>-->
    <v-btn
      v-if="getIsMaster || getIsSuperUser"
      color="primary"
      flat
      @click="openUploadAttendee"
    >
      Upload Attendee
    </v-btn>
    <v-btn
      v-if="getIsMaster || getIsSuperUser"
      color="primary"
      flat
      @click="openUploadNewAttendee"
    >
      Upload new Attendee
    </v-btn>
    <upload-with-excel
      v-if="isOpenUploadAttendee"
      :isShowModal="isOpenUploadAttendee"
      @close="closeUploadAttendee"
    />
    <upload-new-with-excel
      v-if="isOpenUploadNewAttendee"
      :isShowModal="isOpenUploadNewAttendee"
      @closeModal="closeUploadNewAttendee"
      @fetchAttendee="getAttendee()"
    />

    <v-layout row wrap justify-space-around>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by first name"
          v-model="search.firstName"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by last name"
          v-model="search.lastName"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by company"
          v-model="search.company"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by email"
          v-model="search.email"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by booth number"
          v-model="search.boothNumber"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <!-- <v-flex xs2>
        <v-select
          v-if="packagesList.length"
          :items="posiblePackagesList"
          v-model="search.selectedPackage"
          item-value="id"
          item-text="name"
          label="Packages"
        />
      </v-flex> -->
      <v-flex xs2>
        <v-text-field
          append-icon="search"
          label="Search by id"
          v-model="search.id"
          @change="resetSelectedItems"
          :disabled="loading"
        />
      </v-flex>
      <v-flex xs2>
        <v-select
          v-if="statusDisplayNames.length"
          :items="posibleStatusDisplayNames"
          v-model="search.selectedAttendeeStatus"
          item-value="registrationStatus"
          item-text="displayName"
          label="Attendee Status"
          @change="resetSelectedItems"
        />
      </v-flex>
      <v-flex xs2>
        <v-select
          v-if="regularAttendeeType.length"
          :items="posibleRegularAttendeeType"
          v-model="search.selectedAttendeeType"
          item-value="id"
          item-text="title"
          label="Attendee Types"
          @change="resetSelectedItems"
        />
      </v-flex>
      <v-flex xs2>
        <v-select
          v-if="categoriesList.length"
          :items="posibleCategoriesList"
          v-model="search.selectedCategory"
          item-value="id"
          item-text="name"
          label="Categories"
          @change="resetSelectedItems"
        />
      </v-flex>

      <v-flex xs2>
        <v-select
          :items="typesAttendee"
          v-model="search.isVip"
          item-value="value"
          item-text="name"
          label="Vip/Regular"
          @change="resetSelectedItems"
        />
      </v-flex>
    </v-layout>

    <!-- Mass Attendee Actions -->

    <mass-attendee-actions
      @resetSelected="resetSelectedItems"
      :sellectedAttendees="selected"
      @resetCheckboxes="resetSelectedCheckboxes"
    />

    <!-- TABLE -->

    <v-data-table
      v-if="getAllAttendee"
      :rows-per-page-items="pageRows"
      :headers="headers"
      :items="getAllAttendee"
      class="elevation-1 wrap"
      :pagination.sync="pagination"
      :total-items="totalItemsInTable"
      :loading="loading"
      :calculate-widths="true"
      item-key="id"
      :disable-initial-sort="true"
      v-model="selected"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th
          @click="selectAllAttendees"
          >
          <v-icon color="blue" style="cursor: pointer">done</v-icon>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
            :style="`min-width: ${header.width}px`"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <!--select-all-->
      <template slot="items" slot-scope="props">
        <tr v-bind:class="{ blacklisted: props.item.blacklisted, 'in-blacklist': isInBlacklist(props.item) }" :active="props.selected" @click="props.selected = !props.selected">
        <td>
          <v-checkbox
            :input-value="props.selected"
            primary
            hide-details
          />
        </td>
        <td class="py-4 ">{{ props.item.firstName }}</td>
        <td class="py-4">{{ props.item.lastName }}</td>
        <td class="py-4">{{ props.item.company }}</td>
        <td class="py-4">{{ props.item.email }}</td>
        <td class="py-4">{{ props.item.comments }}</td>
        <td class="text-xs-center">
          <v-btn
            flat fab
            color="light-blue darken-2"
            @click.stop="redirectToWebsite(props.item)"
          >W</v-btn>
        </td>
        <td class="py-4">
          <span v-if="props.item.isVip">
            {{props.item.invitationPackage.name}}
          </span>
          <span v-else>{{props.item.package.name}}</span>
        </td>
        <td class="py-4">
          {{props.item.imageUrl ? 'Yes' : 'No'}}
        </td>
        <td class="py-4">
            <!--<span v-if="objOfStatus[props.item.registrationStatus]">-->
              <!--{{ objOfStatus[props.item.registrationStatus].title }}-->
            <!--</span>-->
          {{ makeSentenceCase(props.item.registrationStatus) }}
        </td>
        <td class="py-4" >
          {{ path(['attendeeType', 'title'], props.item) }}
        </td>
        <td class="py-4">
          {{ path(['category', 'name'], props.item) }}
        </td>
        <td class="py-4">
          {{ props.item.subCategory }}
        </td>
        <td class="py-4">
          {{props.item.isVip ? 'VIP' : 'REGULAR'}}
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="lime"
              fab flat
              slot="activator"
              @click.stop="editAttendee(props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="red accent-4"
              fab flat
              slot="activator"
              @click.stop="showConfirmationDeleteForever(props.item)"
            >
              <v-icon>delete_forever</v-icon>
            </v-btn>
            <span>Delete all records</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="orange darken-2"
              fab flat
              slot="activator"
              @click.stop="showAvailableActions(props.item)"
            >
              <v-icon>touch_app</v-icon>
            </v-btn>
            <span>Actions</span>
          </v-tooltip>
        </td>
        </tr>
      </template>
      <template slot="pageText" slot-scope="{}">
        Page {{ pagination.page }} of {{ getTotalPagesAllAttendee }}
      </template>
    </v-data-table>

    <v-dialog persistent v-model="isConfirmationDeleteForever" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are You sure You want to delete the attendee? </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="deleteForever()">Delete forever</v-btn>
          <v-btn color="info" flat @click="hideConfirmationDeleteForever">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isConfirmationUnblock" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are You sure You want to unblock the attendee? </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="unblockAttendee()">Unblock</v-btn>
          <v-btn color="info" flat @click="hideConfirmationUnblock">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isSelectActions" max-width="500px">
      <v-card>
        <v-card-title>
         <h3>Select action for this attendee</h3>
        </v-card-title>

        <v-flex mx-4>
          <v-btn flat color="success" dark @click="chooseEmailTemplaiteForInvitation(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>message</v-icon>
            Send featured attendee invitation
          </v-btn>
        </v-flex>

        <v-flex mx-4>
          <v-btn flat color="primary" dark @click="remindAttendee(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>email</v-icon>
            Ask for more info
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="selectedAttendee.isInTop" >
          <v-btn flat color="amber lighten-1" dark @click="removeFromTopOfList(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>star</v-icon>
            Remove from top of list
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-else>
          <v-btn color="amber lighten-1" flat dark @click="putOnTopOfList(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>star_border</v-icon>
            Put on top of list
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="selectedAttendee.registrationStatus === 'PendingApprove'">
          <v-btn color="green lighten-1" flat dark @click="approveAttendee(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>offline_pin</v-icon>
           Approve
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="isPosibleSendRequestForPayment">
          <v-btn color="purple darken-2" flat dark @click="chooseEmailTemplaiteForSendRequest(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>near_me</v-icon>
           Send Request for payment
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="selectedAttendee.registrationStatus !== 'Rejected'">
          <v-btn color="red" flat dark @click="setStatusReject(selectedAttendee.id)">
            <v-icon class="mr-2" dark right>pan_tool</v-icon>
           Reject user
          </v-btn>
        </v-flex>

        <v-flex mx-4 v-if="selectedAttendee.isBlocked">
          <v-btn color="deep-purple accent-2" flat dark @click="showConfirmationUnblock(selectedAttendee)">
            <v-icon class="mr-2" dark right>lock_open</v-icon>
           Unblock user
          </v-btn>
        </v-flex>

        <v-card-actions>
          <v-btn color="info" flat @click="hideAvailableActions">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isChooseEmailTemplateBlock" max-width="500px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Choose email template for send request for payment</span>
          <v-flex class="py-2">
            <v-select
              :items="requestForPaymentTemplatesList"
              v-model="emailTemplateKey"
              label="Email Template"
              item-value="templateKey"
              item-text="templateKey"
            />
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="cancelActionOfChoose">Cancel</v-btn>
          <v-btn color="success" flat @click="sendRequestForPeyment()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="isSelectETemplateForFAInvitation" max-width="500px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">9Choose email template for send featured attendee invitation</span>
          <v-flex class="py-2">
            <v-select
              :items="featuredAttendeeInvitationTemplatesList"
              v-model="emailTemplateKey"
              label="Email Template"
              item-value="templateKey"
              item-text="templateKey"
            />
          </v-flex>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="cancelActionOfChoose">Cancel</v-btn>
          <v-btn color="success" flat @click="sendFeaturedAttendeeInvitation()">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      max-width="500px"
      v-model="isModalForColumnsChoiceShown"
    >
      <v-card class="pa-4">
        <v-layout>
          <v-flex ma-3>
            <h3>Columns to download:</h3>
            <v-layout row wrap>
              <v-flex xs12 class="my-4">
                <div v-for="(columnName) in columnsNames" :key="`predefined-activity-${columnName}`">
                  <v-checkbox
                    v-model="selectedColumns"
                    :label="columnName"
                    :value="columnName"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import { equals, path, pathOr, clone, isEmpty } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import ContentField from '@/components/shared/ContentField/index.vue'
import UploadWithExcel from '@/components/shared/Upload/uploadWithExcel.vue'
import UploadNewWithExcel from '@/components/shared/Upload/uploadNewWithExcel.vue'
import MassAttendeeActions from './massAttendeeActions'
import mixins from '@/utils/mixins'

export default {
  name: 'AllAttendeeTable',
  components: {
    ContentField,
    UploadWithExcel,
    UploadNewWithExcel,
    MassAttendeeActions
  },
  mixins: [mixins.emailTemplates],
  data () {
    return {
      pagination: {
        rowsPerPage: 100,
        sortBy: 'updateDate',
        descending: true,
        page: 1,
        totalItems: 0
      },
      isModalForColumnsChoiceShown: false,
      selectedColumns: [],
      pageRows: [100, 500,1000,{"text":"All","value":-1}],
      selected: [],
      loadedAttendeesIds: [],
      loading: false,
      listOfAllAttendee: [],
      objOfStatus: {},
      isConfirmationUnblock: false,
      isSelectActions: false,
      itemToUnblock: '',
      isConfirmationDeleteForever: false,
      itemToDeleteForever: '',
      isChooseEmailTemplateBlock: false,
      selectedAttendeeId: '',
      isSelectETemplateForFAInvitation: false,
      selectedAttendee: {},
      emailTemplateKey: '',
      search: {
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        boothNumber: '',
        // selectedPackage: '',
        selectedCategory: '',
        selectedAttendeeType: '',
        selectedAttendeeStatus: '',
        isVip: '',
        id: ''
      },
      typesAttendee: [
        {
          name: 'Any',
          value: ''
        },
        {
          name: 'VIP',
          value: true
        },
        {
          name: 'REGULAR',
          value: false
        }
      ],
      headers: [
        { text: 'First name', value: 'firstName', search: true, sortable: true, width: '100' },
        { text: 'Last name', value: 'lastName', search: true, sortable: true, width: '100' },
        { text: 'Company', value: 'company', search: true, sortable: true, width: '100' },
        { text: 'Email', value: 'email', search: false, sortable: true, width: '100' },
        { text: 'Comments', value: 'comments', search: false, sortable: true, width: '300' },
        { text: 'Website', value: 'website', search: false, sortable: false, width: '40' },
        { text: 'Package', value: 'Package.Name', search: true, sortable: true, width: '100' },
        { text: 'Image', value: 'Image.ImageStatus', sortable: true, width: '30' },
        { text: 'Registration status', value: 'registrationStatus', search: false, sortable: true, width: '150' },
        { text: 'Type', value: 'attendeeTypeId', search: true, sortable: true, width: '100' },
        { text: 'Category', value: 'categoryId', search: true, sortable: true, width: '100' },
        { text: 'Sub Category', value: 'subCategory.name', search: true, sortable: true, width: '100' },
        { text: 'Vip/Regular', value: 'isVip', search: true, sortable: true, width: '100' },
        { text: 'Edit', sortable: false, align: 'center', width: '30' },
        { text: 'Delete all records', sortable: false, align: 'center', width: '30' },
        { text: 'Actions', sortable: false, align: 'center', width: '30' }
      ],
      columnsNames: [
        'Id',
        'CategoryId',
        'AccountManagerEmail',
        'BirthYear',
        'CanReceiveMessages',
        'Company',
        'DynamicCategoryName',
        'Email',
        'FirstName',
        'IsBlocked',
        'IsRemovedFromKillerFeatureSearch',
        'LastName',
        'RegistrationStatus',
        'VatId',
        'SubscribeNewsletter',
        'UniqueId',
        'UniqueCode',
        'SubscribeProductsUpdate'
      ],
      getParams: null,
      isOpenUploadAttendee: false,
      isOpenUploadNewAttendee: false
    }
  },
  computed: {
    ...mapGetters([
      'getAllAttendee',
      'getTotalPagesAllAttendee',
      'getTotalItemsAllAttendee',
      'regularAttendeeType',
      'categoriesList',
      'packagesList',
      'statusDisplayNames',
      'staticContent',
      'getRegularAttendeeStatusesCount',
      'getVipAttendeeStatusesCount',
      'getIsMaster',
      'blackList',
      'getIsSuperUser'
    ]),
    totalItemsInTable () {
        return this.getTotalItemsAllAttendee || (this.getTotalPagesAllAttendee * this.pagination.rowsPerPage)
    },
    posiblePackagesList () {
        return [{ name: 'Any', id: '' }, ...this.packagesList]
    },
    attendeeStatusesCount () {
      return this.getRegularAttendeeStatusesCount
        ? Object.keys(this.getRegularAttendeeStatusesCount).reduce((acc, status) => {
            acc[status] = pathOr(0, [status], this.getRegularAttendeeStatusesCount) + pathOr(0, [status], this.getVipAttendeeStatusesCount)
            return acc
          }, {})
        : {}
    },
    posibleStatusDisplayNames () {
      if (!isEmpty(this.attendeeStatusesCount) && this.statusDisplayNames) {
        let namesList = this.statusDisplayNames.map(status => {
        status.displayName = status.displayName.includes(':')
          ? `${status.displayName.split(':')[0]}: ${this.attendeeStatusesCount[this.camelize(status.registrationStatus)]}`
          : `${status.displayName}: ${this.attendeeStatusesCount[this.camelize(status.registrationStatus)]}`
         return status
        })
        return [{ displayName: 'Any', registrationStatus: '' }, ...namesList]
      }
    },
    isPosibleSendRequestForPayment () {
      const isPendingPayment = this.selectedAttendee.registrationStatus === 'PendingPayment'
      const isRequestPayment = this.selectedAttendee.registrationStatus === 'RequestForPayment'
      return (isPendingPayment || isRequestPayment) && !this.selectedAttendee.isVip
    },
    posibleRegularAttendeeType () {
      return [{ title: 'Any', id: '' }, ...this.regularAttendeeType]
    },
    posibleCategoriesList () {
      return [{ name: 'Any', id: '' }, ...this.categoriesList]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getAttendee()
      },
      deep: true
    },
    search: {
      handler () {
        this.getAttendee()
      },
      deep: true
    },
    getAllAttendee: {
      handler (newVal) {
        // this code handle all updates, event bus not works
        if(!newVal) return
        this.loadedAttendeesIds = this.getAllAttendee.map((attendee) =>
        {return attendee.id}
        )
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'fetchAllAttendee',
      'getCategoriesList',
      'getPackagesList',
      'setAttendeeApproveStatus',
      'getStatusDisplayNames',
      'sendAttendeeReminders',
      'sendFeaturedInvitation',
      'unblockBlockedAttendee',
      'updateIsInTopStatus',
      'sendRequestForPayment',
      'fetchStaticContent',
      'fetchVipAttendeeStatusesCount',
      'fetchRegularAttendeeStatusesCount',
      'deleteAllAttendeeRecords',
      'updatePlaceholderValue',
      'downloadAttendeeExcel',
      'downloadAttendeesExcelAll',
      'getBlackList',
      'rejectAttendee'
    ]),
    path,
    showModalForColumnsChoose () {
      this.isModalForColumnsChoiceShown = true
    },
    resetSelectedItems () {
      this.selected = []
    },
    resetSelectedCheckboxes () {
      this.selected = []
    },
    async approveAttendee (id) {
      try {
        await this.setAttendeeApproveStatus(id)
      } catch (err) {
        console.error(err)
      }
      this.hideAvailableActions()
      this.getAttendee('updateStatus')
      this.resetSelectedItems()
    },
    async setStatusReject (id) {
      try {
        await this.rejectAttendee(id)
      } catch (err) {
        console.error(err)
      }
      this.hideAvailableActions()
      this.getAttendee('updateStatus')
      this.resetSelectedItems()
    },
    showAvailableActions (attendee) {
      this.selectedAttendee = attendee
      this.isSelectActions = true
    },
    isInBlacklist (attendee) {
      const found = this.blackList.find(b => {
        const r = new RegExp(b.tag, 'i')
        return (attendee.firstName + ' ' + attendee.lastName).match(r) || attendee.email.match(r)
      })
      return !!found
    },
    hideAvailableActions() {
      this.isSelectActions = false
      // need due to early data cleansing
      const timerId = setTimeout(()=> this.selectedAttendee = {}, 1000)
      clearTimeout(timerId)
    },
    async sendFeaturedAttendeeInvitation () {
      const payload =  {
        attendeeId: this.selectedAttendeeId,
        emailTemplateKey: this.emailTemplateKey
      }
      try {
        await this.sendFeaturedInvitation(payload)
      } catch (err) {
        console.error(err)
      }
      this.cancelActionOfChoose()
      this.hideAvailableActions()
    },
    async remindAttendee (attendeeId) {
      try {
        await this.sendAttendeeReminders(attendeeId)
      } catch (err) {
        console.error(err)
      }
      this.hideAvailableActions()
      this.resetSelectedItems()
    },
    async removeFromTopOfList (attendeeId) {
      try {
        await this.updateIsInTopStatus({'ids' : [attendeeId], 'isInTop': false})
      } catch (err) {
        console.error(err)
      }
      this.hideAvailableActions()
      this.getAttendee()
      this.resetSelectedItems()
    },
    async putOnTopOfList (attendeeId) {
      try {
        await this.updateIsInTopStatus({'ids' : [attendeeId], 'isInTop': true})
      } catch (err) {
        console.error(err)
      }
        this.hideAvailableActions()
        this.getAttendee()
        this.resetSelectedItems()
    },
    editAttendee (attendee) {
      this.$emit('editAttendee', attendee)
    },
    chooseEmailTemplaiteForSendRequest (attendeeId) {
      this.selectedAttendeeId = attendeeId
      this.isChooseEmailTemplateBlock = true
      this.resetSelectedItems()
    },
    chooseEmailTemplaiteForInvitation (attendeeId) {
      if (this.featuredAttendeeInvitationTemplatesList.length === 1) {
        this.emailTemplateKey = this.featuredAttendeeInvitationTemplatesList[0].templateKey
        this.selectedAttendeeId = attendeeId
        this.sendFeaturedAttendeeInvitation()
      } else {
        this.selectedAttendeeId = attendeeId
        this.isSelectETemplateForFAInvitation = true
        this.resetSelectedItems()
      }
    },
    showConfirmationDeleteForever (item) {
      this.isConfirmationDeleteForever = true
      this.itemToDeleteForever = ''
      this.itemToDeleteForever = item.id
    },
    hideConfirmationDeleteForever () {
      this.isConfirmationDeleteForever = false
      this.itemToDeleteForever = ''
    },
    async deleteForever () {
      try {
        await this.deleteAllAttendeeRecords([this.itemToDeleteForever])
      } catch (err) {
        console.error(err)
      }
      this.hideConfirmationDeleteForever()
      this.getAttendee('deleteAttendee')
    },
    async sendRequestForPeyment() {
      const payload = {
        id: this.selectedAttendeeId,
        emailTemplateKey: this.emailTemplateKey
      }
      try {
        await this.sendRequestForPayment(payload)
      } catch(err) {
        console.error(err)
      }
      this.cancelActionOfChoose()
      this.hideAvailableActions()
      this.getAttendee()
    },
    cancelActionOfChoose() {
      this.isChooseEmailTemplateBlock = false
      this.isSelectETemplateForFAInvitation = false
      this.emailTemplateKey = ''
    },
    showConfirmationUnblock (item) {
      this.isConfirmationUnblock = true
      this.itemToUnblock = ''
      this.itemToUnblock = item.id
    },
    hideConfirmationUnblock () {
      this.isConfirmationUnblock = false
      this.itemToUnblock = ''
    },
    async unblockAttendee () {
      try {
        await this.unblockBlockedAttendee(this.itemToUnblock)
      } catch (err) {
        console.error(err)
      }
      this.hideConfirmationUnblock()
      this.hideAvailableActions()
      this.getAttendee()
    },
    reset () {
      Object.keys(this.search).forEach(val=> this.search[val] = '' )
      this.pagination.sortBy = 'updateDate'
      this.pagination.descending = true
      this.getAttendee()
    },
    camelize (str) {
      if (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
          if (+match === 0) return ""
          return index === 0 ? match.toLowerCase() : match.toUpperCase()
        })
      }
    },
    downloadAttendeesExcel () {
      const { sortBy, descending } = this.pagination
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const getParams = {
        page: 0,
        itemsOnPage: this.pagination.totalItems,
        filter: {
          isVip: this.search.isVip,
          firstName: this.search.firstName,
          lastName: this.search.lastName,
          company: this.search.company,
          email: this.search.email,
          boothNumber: this.search.boothNumber,
          attendeeType: this.search.selectedAttendeeType,
          category: this.search.selectedCategory,
          attendeeStatus: this.search.selectedAttendeeStatus
        },
        sort,
        name
      }
      const exportPaths = clone(this.selectedColumns)
      if (!exportPaths.length) return
      this.downloadAttendeeExcel({ exportPaths, getParams })
    },
    getAttendee: debounce(async function (reloadTrigger) {
        const oldParams = this.getParams
        this.loading = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let itemsOnPage = equals(rowsPerPage, -1) ? this.getTotalItemsAllAttendee : rowsPerPage
        const sort = descending ? 'Desc' : 'Asc'
        const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
        const newPage = page - 1
        const pageCheck = newPage > 0 ? newPage : 0
        const currentParams = {
          page: pageCheck,
          itemsOnPage,
          filter: {
            isVip: this.search.isVip,
            firstName: this.search.firstName,
            lastName: this.search.lastName,
            company: this.search.company,
            email: this.search.email,
            boothNumber: this.search.boothNumber,
            // selectedpackage: this.search.selectedPackage,
            attendeeType: this.search.selectedAttendeeType,
            category: this.search.selectedCategory,
            attendeeStatus: this.search.selectedAttendeeStatus,
            id: this.search.id
          },
          sort,
          name
        }
        this.getParams = currentParams
        await this.fetchAttendeeIfExpediency(currentParams, oldParams, reloadTrigger)
        this.loading = false
      }, 800),
    async fetchAttendeeIfExpediency (currentParams, oldParams, reloadTrigger) {
      try {
        await this.fetchAllAttendee(currentParams)
        await this.fetchRegularAttendeeStatusesCount()
        await this.fetchVipAttendeeStatusesCount()
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
    openUploadAttendee () {
      this.isOpenUploadAttendee = true
    },
    closeUploadAttendee () {
      this.isOpenUploadAttendee = false
    },
    openUploadNewAttendee () {
      this.isOpenUploadNewAttendee = true
    },
    closeUploadNewAttendee () {
      this.isOpenUploadNewAttendee = false
    },
    makeSentenceCase (string) {
      return string.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1")
    },
    selectAllAttendees () {
      let matchingAttendeesIds = this.loadedAttendeesIds.filter(id => {
        const matchingAttendeeId = this.selected.find((selectedAttendee) => selectedAttendee.id === id)
        return matchingAttendeeId
      })
      // if all were selected => deselect all from selected
      if (matchingAttendeesIds.length === this.loadedAttendeesIds.length) {
        this.selected = this.selected.filter((selectedAttendee) => {
          const selectedAttendeeId = matchingAttendeesIds.find(id => selectedAttendee.id === id)
          return !selectedAttendeeId
        })
      } else {
        // if none or some were selected => add not selected
        let attendeesToAdd = this.getAllAttendee.filter((attendee) => {
          const selectedAttendeeId = matchingAttendeesIds.find(id => attendee.id === id)
          return !selectedAttendeeId
        })
        this.selected = this.selected.concat(attendeesToAdd)
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    redirectToWebsite ({email}) {
      let emailDomain = email.split('@')[1]
      window.open(`http://www.${emailDomain}`, '_blank')
    },
    async receiveRequiredData() {
      await Promise.all([
        this.getBlackList(),
        this.getPackagesList(),
        this.getStatusDisplayNames(),
        this.getCategoriesList(),
        this.getAttendee(),
        this.fetchStaticContent(),
        this.fetchRegularAttendeeStatusesCount(),
        this.fetchVipAttendeeStatusesCount(),
      ])
    }
  },
   mounted () {
    // trigger is for force fetch (reload) of attendees after edit
    this.$bus.$on('reloadTable', (reloadTrigger) => this.getAttendee(reloadTrigger))
    //  this.receiveRequiredData()
    // this.objOfStatus = this.statusDisplayNames.reduce((acc, curr) => {
    //   const settings = {
    //     ...curr,
    //     title: curr.displayName.split(':')[0]
    //   }
    //   acc[curr.registrationStatus] = settings
    //   return acc
    // }, {})
  },
  async created () {
    await this.receiveRequiredData()
  },
  beforeDestroy () {
    this.$bus.$off('reloadTable')
  }
}
</script>

<style>
.blacklisted {
  background: #9e9e9e;
}

.in-blacklist {
  background: #ffeb3b;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AllAttendee/AllAttendeeTable.vue